import React from 'react'
import { LoadingOverlay, Group, Pagination, Stack, Table, Title, ScrollArea } from '@mantine/core';

type Column = {
    label: string
    field: string
    format?: (field: string) => string
    color?: (field: string) => string
}

type Props = {
    data: any[]
    dataCount: number
    columns: Column[]
    page?: number
    limit?: number
    isFetching?: boolean
    title?: string
    activeKey?: string
    h?: string | number
    uniqueKey: string
    handleSelect?: (row: any) => void
    handlePageChange?: (page: number) => void
}

export const List = ({ data, dataCount, columns, h = '75vh', page, activeKey, uniqueKey, limit = 50, isFetching, handleSelect = () => undefined, handlePageChange }: Props) => {
    const paginationTotal = Math.ceil((dataCount || 0) / limit)

    return (
        <Stack>
            <ScrollArea h={h}>
                <LoadingOverlay visible={isFetching}/>
                <Table style={{ fontSize: 14, overflow: 'scroll' }} stickyHeader striped highlightOnHover withTableBorder>
                    <Table.Thead>
                        <Table.Tr>
                            { columns.map(c => (
                                <Table.Th key={c.field}>{c.label}</Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {data.map((r, i) => (
                            <Table.Tr key={r[uniqueKey]} style={{ cursor: 'pointer', fontWeight: activeKey === r[uniqueKey] ? 'bold' : 'normal' }} onClick={() => handleSelect(r)}>
                                { columns.map(c => (
                                    <Table.Td key={c.field} c={c.color ? c.color(r[c.field]) : 'dark'}>
                                        {c.format ? c.format(r[c.field]) : r[c.field]}
                                    </Table.Td>
                                ))}
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </ScrollArea>
            { page &&
            <Group justify='center' w='100%'>
                <Pagination total={paginationTotal} value={page} onChange={handlePageChange} />
            </Group> }
        </Stack>
    )
}